import { AppointmentRepository } from '@/core/appointment/domain/AppointmentRepository.ts'
import { AppointmentRequest } from '@/core/appointment/domain/Appointment.ts'

type CreateAppointmentUseCaseDependencies = { appointmentRepository: AppointmentRepository }

export class CreateAppointmentUseCase {
  private readonly appointmentRepository: AppointmentRepository
  constructor({ appointmentRepository }: CreateAppointmentUseCaseDependencies) {
    this.appointmentRepository = appointmentRepository
  }

  execute = (request: AppointmentRequest): Promise<void> => {
    return this.appointmentRepository.createAppointment(request)
  }
}
